import { render, staticRenderFns } from "./MunicipioSelect.vue?vue&type=template&id=4c08fc3a&"
import script from "./MunicipioSelect.vue?vue&type=script&lang=js&"
export * from "./MunicipioSelect.vue?vue&type=script&lang=js&"
import style0 from "./MunicipioSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports